module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAABJUlEQVRIS83XMVLDMBCF4X97Kucq0KcJXRo4JzQ0TKpcIDcJSUO/jBjbE8uWtGvkmJSRpU/akZ5lYaWfBFdVP4En4FVEjkvMRVW3wBtwEpHnDj4DG+Ab2NfGW/QDeAAuIrLp4DCbrqEqHqH92L9wW+7qeAoNXg/XxnPoCK6Fl9BJ+K+4BU3Cc3ErmoW9uActwlbci5rgEj4HNcMpvI2AWcEzOMeljJ5YXegSYtCddi54YuXhLzfqKnUiWu8Dr1Lqqd27+ObKHZnFjpNlYMsz8YnJ7mrPgJ5n/99Lwjv72zJa+45Kbe2YSznLGOtffSyzLGV53F687C2BJiJ2eL1V1S+gmRv4pUpEC7uKSNNd6A/AI/BS+ysiWvl7+wmzc78WS6uztv8A9bksLnCbvVMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/closePerson.png
// module id = 970
// module chunks = 41